const preorderTraversalProblems = [
  {
   title: "Binary Tree Preorder Traversal",
   url: "https://leetcode.com/problems/binary-tree-preorder-traversal/"
  },
  {
    title: "Construct Binary Tree from Preorder and Inorder Traversal",
    url: "https://leetcode.com/problems/construct-binary-tree-from-preorder-and-inorder-traversal/"
  },
  {
    title: "Path Sum",
    url: "https://leetcode.com/problems/path-sum/"
  },
  {
    title: "Flatten Binary Tree to Linked List",
    url: "https://leetcode.com/problems/flatten-binary-tree-to-linked-list/"
  },
  {
    title: "Serialize and Deserialize Binary Tree",
    url: "https://leetcode.com/problems/serialize-and-deserialize-binary-tree/"
  }
];
export default preorderTraversalProblems;